import { useCallback } from 'react';
import { useAuth } from 'react-oidc-context';

const backend = process.env.REACT_APP_BACKEND_URL || 'https://localhost:7009/api';

interface ApiRequestOptions {
  path: string;
  method?: string;
  body?: any;
  headers?: Record<string, string>;
}

export function useApiRequest() {
  const auth = useAuth();

  const apiRequest = useCallback(
    async <T = any>(options: ApiRequestOptions): Promise<T | null | undefined> => {
      const { path, method = 'GET', body, headers = {} } = options;

      try {
        if (!auth.isAuthenticated || !auth.user?.access_token) {
          await auth.signinRedirect();
          return null;
        }

        const fetchOptions: RequestInit = {
          method,
          headers: {
            Authorization: `Bearer ${auth.user.access_token}`,
            'Content-Type': 'application/json',
            ...headers,
          },
        };

        if (body) {
          fetchOptions.body = JSON.stringify(body);
        }

        const resp = await fetch(`${backend}${path}`, fetchOptions);

        if (!resp.ok) {
          const text = await resp.text().catch(() => '');
          throw new Error(`HTTP ${resp.status}: ${text}`);
        }

        return await resp.json().catch(() => null);
      } catch (error: any) {
        console.error(error);
      }
    },
    [auth]
  );

  return apiRequest;
}
